module.exports = __webpack_public_path__ + "static/media/intro.a1694ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/intro.jpg
// module id = 52
// module chunks = 0